import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { SLA } from "./components/sla";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);

    // Fetch live Google reviews and merge with static data
    fetch('/.netlify/functions/google-reviews')
      .then((res) => res.json())
      .then((google) => {
        setLandingPageData((prev) => ({
          ...prev,
          Contact: {
            ...prev.Contact,
            rating: google.rating || prev.Contact?.rating,
            reviewCount: google.reviewCount || prev.Contact?.reviewCount,
          },
          Testimonials: google.reviews && google.reviews.length > 0
            ? google.reviews.map((r) => ({
                text: r.text,
                name: r.name,
                rating: r.rating,
                date: r.time || 'Google Review',
                photo: r.photo,
              }))
            : prev.Testimonials,
        }));
      })
      .catch(() => {
        // Silently fall back to static data from data.json
      });
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} contact={landingPageData.Contact} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} contact={landingPageData.Contact} />
      <Services data={landingPageData.Services} />
      <SLA data={landingPageData.SLA} />
      <Gallery data={landingPageData.Gallery} contact={landingPageData.Contact} />
      <Testimonials data={landingPageData.Testimonials} contact={landingPageData.Contact} />
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
